import {SandboxView} from '@github-ui/sandbox-view'
import {useState} from 'react'

import type {ArtifactHtmlPreviewPayload, ArtifactHtmlPreviewPlan} from '../../utils/artifacts/html-preview-plan'

interface HtmlPreviewRenderProps {
  isVisible: boolean
  previewRevision: number
  previewUrl: string
}

interface ArtifactHtmlPreviewProps extends HtmlPreviewRenderProps {
  payload: ArtifactHtmlPreviewPayload
  signature: string
}

export function ArtifactHtmlPreview({
  payload,
  signature,
  isVisible,
  previewRevision,
  previewUrl,
}: ArtifactHtmlPreviewProps) {
  const [committed, setCommitted] = useState(() => (isVisible ? {payload, signature, generation: 0} : undefined))

  if (isVisible && committed?.signature !== signature) {
    setCommitted({payload, signature, generation: (committed?.generation ?? -1) + 1})
  }

  if (!committed) return null

  return (
    <SandboxView
      key={`${committed.generation}:${previewRevision}`}
      content={committed.payload.content}
      inlineScripts={committed.payload.inlineScripts}
      viewscreenUrl={previewUrl}
    />
  )
}

export function createArtifactHtmlPreview(plan: Extract<ArtifactHtmlPreviewPlan, {kind: 'prepared'}>, id: string) {
  return {
    signature: plan.signature,
    render: (props: HtmlPreviewRenderProps) => (
      <ArtifactHtmlPreview key={id} {...props} payload={plan.payload} signature={plan.signature} />
    ),
  }
}
